import { Breadcrumb } from "semantic-ui-react";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import LoadingWrapper from "~/components/wrapper/LoadingWrapper";
import ModalError from "~/components/element/ModalError";
import ContentLoader from "~/components/element/ContentLoader";
import ToastMessageStore from "~/stores/ToastMessageStore";
import ToastMessageContainer from "~/components/ToastMessageContainer";
import CustomerStore from "~/stores/CustomerStore";
import CreditCardFormStore from "~/stores/Credit/CreditCardFormStore";
import Link from "~/components/element/Link";
import CreditCardForm from "~/modules/BillingCentral/components/CreditCardForm";
import RouteWrapper from "~/components/wrapper/RouteWrapper";
import ProviderStore from "~/stores/Provider/ProviderStore";

@observer
class AddCreditCardPage extends Component {
  @observable creditCardFormStore = null;

  constructor(props) {
    super(props);

    const { t } = props;
    document.title = t("billingCentral:addCreditCard");

    this.creditCardFormStore = new CreditCardFormStore();

    this.stripePromise = loadStripe(props.stripeApiPublishableKey);
  }

  render() {
    const { t, toastMessageStore, redirectTo, actualUserStore } = this.props;
    const { isLoading: actualUserLoading } = actualUserStore;
    const { isSaving: creditCardSaving } = this.creditCardFormStore.creditCardStore;

    if (actualUserLoading) {
      return <ContentLoader />;
    }

    return (
      <>
        <LoadingWrapper loading={creditCardSaving} message={t("saving")} />
        <ModalError nestStore={this.creditCardFormStore.creditCardStore} />

        <div className="side-page-outer-container">
          <Breadcrumb>
            <Breadcrumb.Section>
              <Link to="/billing-central">{t("billingCentral:billingCentral")}</Link>
            </Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>{t("billingCentral:addCreditCard")}</Breadcrumb.Section>
          </Breadcrumb>

          <div className="side-page-header">
            <div className="side-page-h1-wrap">
              <h1>{t("billingCentral:addCreditCard")}</h1>
            </div>
          </div>

          <Elements stripe={this.stripePromise}>
            <ElementsConsumer>
              {({ stripe, elements }) => (
                <CreditCardForm
                  creditCardFormStore={this.creditCardFormStore}
                  actualUserStore={actualUserStore}
                  stripe={stripe}
                  elements={elements}
                  creditCardCreatedCallback={() => {
                    actualUserStore.needReload = true
                    redirectTo("/billing-central")
                  }}
                  toastMessageStore={toastMessageStore}
                />
              )}
            </ElementsConsumer>
          </Elements>
        </div>
        <ToastMessageContainer toastMessageStore={toastMessageStore} />
      </>
    );
  }
}

AddCreditCardPage.propTypes = {
  t: PropTypes.func.isRequired,
  toastMessageStore: PropTypes.instanceOf(ToastMessageStore),
  actualUserStore: PropTypes.oneOfType([PropTypes.instanceOf(ProviderStore), PropTypes.instanceOf(CustomerStore)]),
  stripeApiPublishableKey: PropTypes.string.isRequired,
};

export default withTranslation()(RouteWrapper(AddCreditCardPage));
